const DefinitionBlock = ({ term, definition }: { term: string; definition: string }) => (
  <div className="flex flex-col gap-2 rounded-2xl border border-[#CACFD8] bg-[#F9FBFF] px-5 py-6 sm:px-8 sm:py-7">
    <span className="text-[10.5px] font-semibold uppercase tracking-[0.14em] text-[#8B93A7]">
      {term} in short
    </span>
    <p className="answer-first text-[17px] font-medium leading-[1.6] text-[#101828] sm:text-[19px]">
      {definition}
    </p>
  </div>
);

export default DefinitionBlock;
